import { BusinessAccountsTermsOfUseResp } from 'types/api/response/business-accounts-terms-of-use-resp'

import { api } from './api'

export const getPrivateBetaTermsOfUseContent = () =>
  api.get<BusinessAccountsTermsOfUseResp>('/private_beta_terms_of_use')
